export default __webpack_public_path__ + "static/what-1000-a-month-accomodation-gets-you-hero-image-c2208f1833f533c3a025f9de4be0c8b0.jpg";